import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';

@ManageType('PrescriptionEditDialogComponent')
@Component({
  selector: 'app-prescription-edit-dialog',
  templateUrl: './prescription-edit-dialog.component.html',
  styleUrls: ['./prescription-edit-dialog.component.scss']
})
export class PrescriptionEditDialogComponent implements OnInit {

  public entry: CNPrescriptionEntry;

  constructor(@Inject(MAT_DIALOG_DATA) public data: {entry: CNPrescriptionEntry},
              public dialogRef: MatDialogRef <PrescriptionEditDialogComponent>) {
    this.entry = data.entry;
  }

  ngOnInit(): void {
  }

  save() {
    this.dialogRef.close(this.entry);
  }
}
